  <ng-container *ngIf="communityDetails; else elseBlock">
    <div [ngClass]="{'rounded my-3 mt-md-0': !communityDetails.flags.view_more}"
      class="text-left community-card-container">
      <div class="mb-2">
        <div class="heading-4">
          {{communityDetails.label}}
        </div>
        <div class="secondary-paragraph"><span class="color-grey-500">{{communityDetails.sub_text}}</span></div>
      </div>
      <div class="clearfix">
        <ng-content></ng-content>
      </div>
      <div *ngIf="communityDetails.list.length === 0"
        class="paragraph-bold d-flex flex-column py-3 align-items-center justify-content-center h-100 text-center">
        <img src="assets/themes/images/community-no-data.svg" alt="no community data"/>
        <p class="pt-4 w-75 paragraph">
          <span *ngIf="communityDetails.key === communityListType.MY_COMMUNITY; else elseCommunity">
            {{translations.key3}}
          </span>
          <ng-template #elseCommunity>
              <span *ngIf="!isPastCommunity">{{translations.key4}}</span>
              <ul>
                <li *ngIf="communityDetails?.key === communityListType.PAST_COMMUNITY">{{translations.key5}}</li>
                <li *ngIf="communityDetails?.key === communityListType.INACTIVE_COMMUNITY">{{translations.key6}}</li>
              </ul>
          </ng-template>
        </p>
      </div>
    </div>
    <ng-container *ngIf="communityDetails.flags.view_more && communityDetails.list.length < numbers.ELEVEN">
      <div class="text-center view-more-container  mb-4">
        <button class="btn-design small outline view-more px-2" type="button"
          (click)="filter(communityDetails?.key)">
          {{mls.languageText.community.key119}} <img src="assets/themes/icons/right-arrow-head.svg" class="ml-1" alt="down arrow icon">
        </button>
      </div>
    </ng-container>
  </ng-container>
  <ng-template #elseBlock>
    <div
      class="d-flex flex-column align-items-center justify-content-center h-100 text-center mt-4">
      <img src="assets/themes/images/community-no-data.svg" alt="no community data"/>
      <p class="pt-4 w-75 paragraph">
        {{translations.key3}}
      </p>
    </div>
  </ng-template>